<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="account-profile"
          title="Account Profile"
          details="User profile and organization details."
        >
          <template v-slot:img>
            <account-profile-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="organization-hierachy"
          title="Organization Hierachy"
          details="Functions, job level, people and designations."
        >
          <template v-slot:img>
            <organization-hierachy-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="users-and-groups"
          title="Users And Groups"
          details="Users and groups in your organization."
        >
          <template v-slot:img>
            <users-groups-svg />
          </template>
        </settings-card>
      </div>

      <!-- </div>

    <div class="row"> -->
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="roles-and-privileges"
          title="Roles And Privileges"
          details="Setup Roles and Privilege for your organisation."
        >
          <template v-slot:img>
            <roles-privileges-svg />
          </template>
        </settings-card>
      </div>
      <!-- </div>

    <div class="row"> -->

      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="location-and-tax"
          title="Location and Tax"
          details="Office locations, tax policies and jurisdictions"
        >
          <template v-slot:img>
            <location-tax-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="routes"
          title="Routes"
          details="Markup and discounts, categories and brands."
        >
          <template v-slot:img>
            <routes-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="vehicles"
          title="Vehicle Registration"
          details="Manage your outlets and saved inventories here."
        >
          <template v-slot:img>
            <vehicle-registration-svg />
          </template>
        </settings-card>
      </div>
      <!-- </div>

    <div class="row"> -->
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="security-policy"
          title="Security Policy"
          details="Security policies (passwords, 2FA, and security questions)."
        >
          <template v-slot:img>
            <security-policy-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          title="Dynamic Numbering Sys"
          details="Product SKUs, invoice codes, waybill codes etc."
        >
          <template v-slot:img>
            <dynamic-numbering-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          title="Messaging"
          details="All in-app activities and timelines."
        >
          <template v-slot:img>
            <time-management-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="approval"
          title="Approval"
          details="Business outlet, tax policies and jurisdictions ..."
        >
          <template v-slot:img>
            <location-tax-svg />
          </template>
        </settings-card>
      </div>
      <!-- </div>

    <div class="row"> -->
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          title="Apps and Subscriptions"
          details="Your subscriptions and apps."
        >
          <template v-slot:img>
            <apps-subscriptions-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          to="payments-and-collections"
          title="Payments and Collections"
          details="Setup Roles and Privilege for your organisation."
        >
          <template v-slot:img>
            <payments-collections-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          title="Document Templates"
          details="View and edit your file templates."
        >
          <template v-slot:img>
            <document-template-svg />
          </template>
        </settings-card>
      </div>
      <div class="col-md-4 col-lg-3 col-12">
        <settings-card
          title="Activity Logs"
          details="All in-app activities and timelines."
        >
          <template v-slot:img>
            <activity-logs-svg />
          </template>
        </settings-card>
      </div>

      <div class="col-md-3 col-lg-3 col-12 pl-0">
        <settings-card
          title="Time Management"
          details="All in-app activities and timelines."
        >
          <template v-slot:img>
            <time-management-svg />
          </template>
        </settings-card>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsCard from "./SettingsCard";
import AccountProfileSvg from "./svgs/AccountProfileSvg";
// import OrganizationSettingsSvg from "./svgs/OrganizationSettingsSvg";
import UsersGroupsSvg from "./svgs/UsersGroupsSvg";
import RolesPrivilegesSvg from "./svgs/RolesPrivilegesSvg";
import OrganizationHierachySvg from "./svgs/OrganizationHierachySvg";
import LocationTaxSvg from "./svgs/LocationTaxSvg";
import RoutesSvg from "./svgs/RouteSvg";
import ActivityLogsSvg from "./svgs/ActivityLogSvg";
import AppsSubscriptionsSvg from "./svgs/AppsSubscriptionSvg";
import DocumentTemplateSvg from "./svgs/DocumentTemplateSvg";
import DynamicNumberingSvg from "./svgs/DynamicNumberingSvg";
import PaymentsCollectionsSvg from "./svgs/PaymentsCollectionsSvg";
import SecurityPolicySvg from "./svgs/SecurityPolicySvg";
import TimeManagementSvg from "./svgs/TimeManagementSvg";
import VehicleRegistrationSvg from "./svgs/VehicleRegistrationSvg";
export default {
  components: {
    SettingsCard,
    AccountProfileSvg,
    // OrganizationSettingsSvg,
    UsersGroupsSvg,
    RolesPrivilegesSvg,
    OrganizationHierachySvg,
    LocationTaxSvg,
    RoutesSvg,
    ActivityLogsSvg,
    AppsSubscriptionsSvg,
    DocumentTemplateSvg,
    DynamicNumberingSvg,
    PaymentsCollectionsSvg,
    SecurityPolicySvg,
    TimeManagementSvg,
    VehicleRegistrationSvg,
  },
};
</script>

<style scoped>
.row div:first-of-type {
  padding-left: 0;
}
.row {
  margin: 1rem 0;
}
.row div {
  padding-left: 0;
  padding-right: 1rem;
  margin-bottom: 1rem;
}
@media screen and (max-width: 768px) {
  .row div {
    margin-bottom: 0.5rem;
    padding-left: 0;
    padding-right: 0;
  }
  .row {
    margin: 0;
  }
}
</style>
